import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  text: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 12,
    textAlign: 'center',
    maxWidth: 70,
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
  containerFlat: {
    marginTop: 20,
  },
});
